import Lottie from 'lottie-react';
import worktualLoader from "./worktual-loader.json"
import Worktualoader from '../../styles/assets/loader/loader.gif'

const Loaders = () => {
  return (
    <>
      <div className={"loaders"}>
        {/* <Lottie
          style={{ width: 100, margin: "0 auto" }}
          animationData={worktualLoader}
        /> */}
        <img src={Worktualoader} alt="Worktualoader" style={{height: '80px'}} />
      </div>
    </>
  );
};
export default Loaders;